module.exports = __webpack_public_path__ + "media/images/store_badges/google_play/google_play_fr-c7cce9cbe2da4ce73a173a4b7b15baf1.png";